import { Avatar, Divider, List, Select, Card, Statistic, Row, Col, Table, Progress, Space, Collapse, Badge, Popover, Skeleton } from "antd";
import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useQueries, useQuery } from "react-query";
import constants from "../../constants";
import useView from "../../hooks/useView";
import { CheckCircleTwoTone, DownOutlined, UpOutlined, LockOutlined, WarningTwoTone, LoadingOutlined } from "@ant-design/icons";
import TaskSumbission from "./TaskSumbission";

const fetchBatch = () => {
  const url = `${constants.NEW_DOMAIN}/api/v1/slot/getSlots?slotId:sw=DUBAI`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${process.env.REACT_APP_JWT_TOKEN}`,
    },
  });
};

const fetchUsers = ({ queryKey }) => {
  const batchId = queryKey[1];

  const url = `${constants.NEW_DOMAIN}/api/v1/user/findForSlot/${batchId}`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${process.env.REACT_APP_JWT_TOKEN}`,
    },
  });
};

const InternshipProgress = () => {
  const { isMobile } = useView();
  const [batch, setbatch] = useState(undefined);
  const [expandedStudents, setExpandedStudents] = useState(new Set());
  const [taskData, setTaskData] = useState(null);
  const totalTasks = batch?.timeLine?.length || Infinity;

  // query batch
  const {
    data: batchResponse,
    isLoading: isBatchLoading,
    isError: isErrorFetchingBatch,
    error,
  } = useQuery("batches", fetchBatch, {
    cacheTime: 24 * 60 * 60 * 1000,
    staleTime: 60 * 60 * 1000,
    select: (data) => {
      return data?.data?.data || [];
    },
  });

  const {
    data: userResponse,
    isLoading: isUsersLoading,
    isError: isErrorFetchingUser,
  } = useQuery(["user", batch?._id], fetchUsers, {
    enabled: !!batch,
    cacheTime: 10 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    select: (data) => {
      return (data?.data?.data || []).map((userData, idx) => {
        return {
          key: userData?._id || idx,
          name: userData?.userId?.name || "N/A",
          phone: userData?.userId?.phone || "N/A",
          email: userData?.userId?.email || "N/A",
          school: userData?.userId?.profile?.school || "N/A",
          city: userData?.userId?.profile?.city || "N/A",
          age: userData?.userId?.profile?.age || "N/A",
          tasks: Object.keys(userData?.progress?.internship_v1 || {}).reduce((acc, key) => {
            // key = week1...week2 and so on
            let tasks = userData.progress.internship_v1[key];
            let task = {};
            if (Array.isArray(tasks) && tasks.length > 0) {
              task = tasks[tasks.length - 1];
            } else {
              task = {};
            }
            acc[key] = task;
            return acc;
          }, {}),

          get progress() {
            const totalTaskDone = Object.values(this.tasks).reduce((acc, task) => {
              if (task.fileUrl && task.description) {
                return acc + 1;
              } else {
                return acc;
              }
            }, 0);

            return Math.floor((totalTaskDone * 100) / totalTasks);
          },
        };
      });
    },
  });

  const toggleStudentExpansion = (studentKey) => {
    const newExpanded = new Set(expandedStudents);
    if (newExpanded.has(studentKey)) {
      newExpanded.delete(studentKey);
    } else {
      newExpanded.add(studentKey);
    }
    setExpandedStudents(newExpanded);
  };

  const getDayIcon = (schedule, data) => {
    const weekId = `week${schedule.id}`;

    const currentTime = Date.now();
    const startDate = new Date(schedule.startDate || "").getTime();
    const endDate = new Date(schedule.endDate || "").getTime();
    //if task is done
    if (data.tasks[weekId]?.description && data.tasks[weekId]?.fileUrl) {
      return <CheckCircleTwoTone twoToneColor="#16a34a" />;
    }

    // future date
    if (currentTime < startDate) {
      return <LockOutlined />;
    }
    // task ongoing
    if (currentTime < endDate) {
      return <Badge status="processing" />;
    }
    // task is not subbmited within the deadline
    return <WarningTwoTone twoToneColor="#ef4444" />;
  };

  if (isUsersLoading) {
    return (
      <div
        style={{
          padding: "16px",
          backgroundColor: isMobile ? "#f8fafc" : "transparent",
          minHeight: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Skeleton active />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "16px",
        backgroundColor: isMobile ? "#f8fafc" : "transparent",
        minHeight: isMobile ? "100vh" : "auto",
      }}
    >
      <TaskSumbission open={Boolean(taskData)} data={taskData} close={() => setTaskData(null)} />
      <h2
        style={{
          marginBottom: 12,
          color: isMobile ? "#1f2937" : "inherit",
          fontSize: isMobile ? "24px" : "inherit",
          fontWeight: isMobile ? "bold" : "inherit",
        }}
      >
        Internship Progress Dashboard
      </h2>
      <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", marginBottom: 16 }}>
        <span style={{ fontWeight: 500, color: isMobile ? "#374151" : "inherit" }}>Batch:</span>
        <Select
          style={{ minWidth: 240 }}
          loading={isBatchLoading}
          value={batch?._id}
          placeholder="Select a batch"
          onChange={(e) => {
            setbatch(() => {
              return (batchResponse || []).find((data) => data._id == e);
            });
          }}
          options={(batchResponse || []).map((batch) => {
            return { value: batch._id, label: batch.description };
          })}
        />
      </div>

      <Row gutter={[12, 12]} style={{ marginBottom: 24 }}>
        <Col xs={12} sm={12} md={6}>
          <Card>
            <Statistic title="Total Students" value={userResponse?.length || 0} />
          </Card>
        </Col>
        <Col xs={12} sm={12} md={6}>
          <Card>
            <Statistic
              title="Avg Progress"
              value={userResponse?.length ? Math.round(userResponse.reduce((acc, cur) => acc + (cur.progress || 0), 0) / userResponse.length) : 0}
              suffix="%"
            />
          </Card>
        </Col>
      </Row>

      <Divider orientation="left" style={{ marginTop: 16 }}>
        Student Progress Overview
      </Divider>

      {isMobile ? (
        // Mobile Card View
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {(userResponse || []).map((student, index) => {
            const isExpanded = expandedStudents.has(student.key);

            return (
              <Card
                key={student.key}
                style={{
                  borderRadius: "12px",
                  border: "1px solid #e5e7eb",
                  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                  backgroundColor: "white",
                }}
                bodyStyle={{ padding: "16px" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                  }}
                  onClick={() => toggleStudentExpansion(student.key)}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 12, flex: 1 }}>
                    {/* <UserOutlined
                      style={{
                        fontSize: "20px",
                        color: "#9ca3af",
                        backgroundColor: "#f3f4f6",
                        padding: "8px",
                        borderRadius: "50%",
                      }}
                    /> */}
                    <Avatar src={`https://api.dicebear.com/7.x/pixel-art-neutral/svg?seed=${index}`} />
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          fontWeight: "bold",
                          color: "#1f2937",
                          fontSize: "16px",
                          marginBottom: "4px",
                        }}
                      >
                        {student.name}
                      </div>
                      <div
                        style={{
                          color: "#6b7280",
                          fontSize: "14px",
                          marginBottom: "8px",
                        }}
                      >
                        {/* {student.progress}% complete */}
                        {student.progress}% complete
                      </div>
                      {/* <Progress percent={student.progress || 0} showInfo={false} strokeColor="#3b82f6" trailColor="#e5e7eb" style={{ width: "100%" }} /> */}
                      <Progress percent={student.progress} showInfo={false} strokeColor="#3b82f6" trailColor="#e5e7eb" style={{ width: "100%" }} />
                    </div>
                  </div>
                  <div style={{ marginLeft: 12 }}>
                    {isExpanded ? (
                      <UpOutlined style={{ color: "#6b7280", fontSize: "16px" }} />
                    ) : (
                      <DownOutlined style={{ color: "#6b7280", fontSize: "16px" }} />
                    )}
                  </div>
                </div>

                {isExpanded && (
                  <div
                    style={{
                      marginTop: 16,
                      paddingTop: 16,
                      borderTop: "1px solid #e5e7eb",
                    }}
                  >
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(5, 1fr)",
                        gap: 12,
                        marginBottom: 12,
                      }}
                    >
                      {(batch.timeLine || []).map((schedule) => {
                        const weekId = `week${schedule.id}`;
                        return (
                          <div
                            key={schedule.id}
                            style={{ textAlign: "center" }}
                            onClick={() => {
                              setTaskData({ userData: student, schedule });
                            }}
                          >
                            <div
                              style={{
                                color: "#6b7280",
                                fontSize: "12px",
                                marginBottom: "4px",
                                fontWeight: "500",
                              }}
                            >
                              Day {schedule.id}
                            </div>
                            <div> {getDayIcon(schedule, student)}</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </Card>
            );
          })}
        </div>
      ) : (
        // Desktop Table View
        <Table
          size="middle"
          pagination={{ pageSize: 10 }}
          dataSource={userResponse || []}
          columns={[
            {
              title: "Student",
              dataIndex: "name",
              key: "student",
              render: (text, record, index) => (
                <Space>
                  <Avatar src={`https://api.dicebear.com/7.x/pixel-art-neutral/svg?seed=${index}`} />
                  <div>
                    <div style={{ fontWeight: 500 }}>{text}</div>
                    <div style={{ color: "#6b7280", fontSize: 12 }}>{record.email}</div>
                  </div>
                </Space>
              ),
            },
            {
              title: "Progress",
              key: "progress",
              render: (_, record) => (
                <div style={{ minWidth: 160 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    {/* <Progress percent={record.progress || 0} showInfo={false} strokeColor="#3b82f6" />
                    <span style={{ width: 36, textAlign: "right" }}>{record.progress || 0}%</span>  */}
                    <Progress percent={record.progress} showInfo={false} strokeColor="#3b82f6" />
                    <span style={{ width: 36, textAlign: "right" }}>{record.progress}%</span>
                  </div>
                </div>
              ),
            },

            ...(batch?.timeLine || []).map((schedule) => {
              const weekId = `week${schedule.id}`;
              return {
                title: `Day ${schedule.id}`,
                key: `day_${schedule.id}`,
                align: "center",
                render: (_, record) => {
                  return (
                    <div
                      onClick={() => {
                        setTaskData({ userData: record, schedule });
                      }}
                    >
                      {getDayIcon(schedule, record)}
                    </div>
                  );
                },
              };
            }),
          ]}
        />
      )}
    </div>
  );
};

export default InternshipProgress;
